<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">
        <section slot="above-content" class="gz-action-section_default">
            <GZ-BaseButton
                value="добавить проверку"
                class="gz-button gz-button_default" 
                icon="icon-clipboard"
                @click="setCheckup"
            />
        </section>

        <!-- <section slot="filters" class="gz-filters gz-checkup__row">
            <gz-input-container 
                type="filter"
                label="Дата проверки"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
            <gz-input-container 
                type="filter"
                label="Кто проверил"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
            <gz-input-container 
                type="filter"
                label="Номер акта"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
            <gz-input-container 
                type="filter"
                label="Статус"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
            <gz-input-container 
                type="filter"
                label="Верификация"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
            <gz-input-container 
                type="filter"
                label="Фото"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
            <gz-input-container 
                type="filter"
                label="Комментарии"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
            <gz-input-container 
                type="filter"
                label="Опции"
                class="gz-filter__item gz-checkup__col gz-checkup__col__title"    
            >
            </gz-input-container>
        </section>
        
        <section slot="content" v-if="contentLoading">
            <GZ-MainPageLoader />
        </section>
        
        <section slot="content" v-if="!contentLoading">
            <CheckupRow 
                v-for="(items, index) in checkupsComputed"
                :key="index"
                :items="items"
                :isAddress="true"
            />
        </section> -->

        
        <table class="gz-table" slot="content">
            <thead class="gz-table__head">
                <tr class="gz-table__filter-labels gz-table__filter-labels_solid">
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Дата проверки</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Кто проверил</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Номер акта</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Статус</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Верификация</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Фото</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Комментарии</span></td>
                    <td class="gz-table__filter-label gz-table__filter-label_solid"><span>Опции</span></td>
                </tr>
            </thead>
            <tbody 
                v-for="(item, index) in checkupsComputed"
                :key="index"
            >
                <CheckupRow :item="item"/>
            </tbody>
        </table>
    </gz-auth-view-template>
</template>

<script>
import CheckupRow from '@/components/custom/admin/views/addresses/CheckupRow'
import Checkup from '@/components/custom/admin/views/addresses/BaseCheckup'

export default {
    name: 'SingleAddressSchedule',

    components: {
        CheckupRow,
        Checkup
    },
    data() {
        return {
            checkups: [],
            contentLoading: false
        }
    },
    computed: {
        addressCheckupStatus() {
        //Меняет значение после добавления/редактирования проверки. Отрабатывает в watch
            return this.$store.getters['addressCheckupStatus']
        },
        checkupsComputed() {
            return this.checkups
        }
    },
    mounted() {
        this.contentLoading = true
        this.$store.dispatch('checkupsBuildingGet', this.$route.params.id)
            .then(() => {
                this.checkups = this.$store.getters['checkupsBuilding']
                this.contentLoading = false
            })
    },
    methods: {
        setCheckup() {
        //Добавить проверку
            this.$store.dispatch('modalOpen', {
                component: Checkup,
                data: {
                    id: this.$route.params.id,
                    objectType: 'bid'
                }               
            })
        }
    },
    watch: {
        addressCheckupStatus: function(newVal) {
        
        this.contentLoading = true
            this.$store.dispatch('checkupsBuildingGet', this.$route.params.id)
                .then(() => {
                    this.checkups = this.$store.getters['checkupsBuilding']
                    this.contentLoading = false
                })
        }
    }
}
</script>